import { ReactNode } from 'react';
// import { NavLink as NavLinkes } from 'react-router-dom';
import {
  Box,
  Flex,
  Avatar,
  Link,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  useDisclosure,
  useColorModeValue,
  Stack,
  useColorMode,
  Text,
  Center,
  Image,
  Drawer,
} from "@chakra-ui/react";


// import React from 'react'
// import { Button } from '@chakra-ui/react'
import { Link as NavLinkes} from 'react-scroll';
import { MoonIcon, SunIcon } from '@chakra-ui/icons';
import { FiDownload } from 'react-icons/fi';
import myphoto from "../Components/assets/myphoto.png"
import Drawerfun from '../Components/Drawer';


const NavLink = ({ children }) => (
  <Link
    px={2}
    py={1}
    rounded={'md'}
    _hover={{
      textDecoration: 'none',
      bg: useColorModeValue('gray.200', 'gray.700'),
    }}
    href={'#'}>
    {children}
  </Link>
);

export default function Navbarfun() {

  const { colorMode, toggleColorMode } = useColorMode();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleresume=()=>{
    window.open('https://drive.google.com/file/d/1w9zO6biz20SPgIQ2KU7j8U16AfaQKnNk/view?usp=share_link',"_blank")
  }


  return (
    <>
      <div className='navbarfixed' id="nav-menu">

        <Box useColorModeValue={"black,black"} px={4} overflow={"hidden"} height={"70px"} borderBottom={"1px solid white"}>
          <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
            {/* <NavLinkes to="home" */}
              {/* smooth */}
            {/* > */}

              <Box width={{ base: "200px", sm: "340px", md: "200px", xl: "450px" }}><span className='logo'>FOLIO</span> <b className='dot'>.</b>
              </Box>
            {/* </NavLinkes> */}
            <Box width={{ base: "none", sm: "none", md: "40%" }} className='navItems' display={{ base: "none", sm: "none", md: "flex", xl: "flex" }} gap={"20px"} style={{ width: "75%", fontSize: "20px" }} cursor={"pointer"}>
              <NavLinkes to="home"
                activeClass="active" smooth spy
                className="nav-link home"
                color='white'

              >
               <Text  color='white'>
                 Home
                </Text>

              </NavLinkes >
              <NavLinkes to="about"
              className="nav-link about"
                activeClass="active" smooth spy
               
                >
                   <Text  color='white'>
               About
                </Text>
              </NavLinkes>
              {/* <NavLinkes to="resume" */}
              {/* // className="nav-link resume"
              //   activeClass="active" smooth spy >
              //  Resume */}
              {/* // </NavLinkes> */}
       
              <NavLinkes to="skills"
              className="nav-link skills"
                activeClass="active" smooth spy>
                <Text  color='white'>
                Skills
                </Text>
              </NavLinkes>
              <NavLinkes to="projects"
              className="nav-link projects"
                activeClass="active" smooth spy >
                 <Text  color='white'>
                 Projects
                </Text>
              </NavLinkes>
              <NavLinkes to="contact"
              className="nav-link contact"
                activeClass="active" smooth spy>
                   <Text  color='white'>
                 Contact
                </Text>
              </NavLinkes>

             


<button id="resume-button-1"  class="nav-link resume" style={{color:colorMode == 'light' ?"black":"white",fontSize:"15px"}}  onClick={handleresume}>

             <a href="Uzair_Resume.pdf"  download="Uzair_Resume.pdf" id="resume-link-1">
             <Button><Text style={{color:colorMode == 'light' ?"black":"white",fontSize:"15px"}}>Resume</Text>
             
          <img width={"25px"} height={"20px"} src="https://cdn.iconscout.com/icon/premium/png-512-thumb/download-1889464-1597509.png?f=avif&w=256" alt="" />
             </Button>

             </a>
               </button>



            </Box>
            <Flex alignItems={'center'}>
              <Stack direction={'row'} spacing={7}>
                <Button onClick={toggleColorMode}>
                  {colorMode === 'light' ?<MoonIcon />:<SunIcon />}
                </Button>
              <Drawerfun />
              </Stack>
            </Flex>
          </Flex>
        </Box>
      </div>
    </>
  );
}